import { Company } from "src/types/data"; 

// Function to get beneficiaires from Check (inside Carnet) for an array of companies
// export const getBeneficiairesFromChecks = (companies: Company[]): string[] => {
//   if(!companies) return [];
//   const beneficiairesSet = new Set<string>();

//   companies.forEach(company => {
//     company.ribs.forEach((rib) => {
//       rib.carnets.forEach((carnet) => {
//         carnet.checks.forEach((check) => {
//           // Convert beneficiaire to uppercase before adding to the Set
//           beneficiairesSet.add(check.beneficiere.toUpperCase());
//         });
//       });
//     });
//   });

//   // Convert the Set to an array to return unique beneficiaires in uppercase
//   return Array.from(beneficiairesSet);
// };
export const getBeneficiairesFromChecks = (companies: Company[]): string[] => {
  if (!companies) {
    console.warn("Companies array is null or undefined.");
    return [];
  }

  const beneficiairesSet = new Set<string>();

  companies.forEach(company => {
    if (!company.ribs) {
      console.warn(`Company ${company.id} has no ribs.`);
      return;
    }

    company.ribs.forEach((rib) => {
      if (!rib.carnets) {
        console.warn(`Rib ${rib.id} has no carnets.`);
        return;
      }

      rib.carnets.forEach((carnet) => {
        if (!carnet.checks) {
          console.warn(`Carnet ${carnet.id} has no checks.`);
          return;
        }

        carnet.checks.forEach((check) => {
          if (!check.beneficiere) {
            console.warn(`Check ${check.id} has no beneficiere.`);
            return;
          }

          beneficiairesSet.add(check.beneficiere.toUpperCase());
        });
      });
    });
  });

  return Array.from(beneficiairesSet);
};

// Function to get beneficiaires from ReceivedCheck (inside Rib) for an array of companies
// export const getBeneficiairesFromReceivedChecks = (companies: Company[]): string[] => {
//   if(!companies) return [];
//   const beneficiairesSet = new Set<string>();

//   companies.forEach(company => {
//     company.ribs.forEach((rib) => {
//       rib.recieved_checks.forEach((receivedCheck) => {
//         // Convert beneficiaire to uppercase before adding to the Set
//         beneficiairesSet.add(receivedCheck.beneficiere.toUpperCase());
//       });
//     });
//   });

//   // Convert the Set to an array to return unique beneficiaires in uppercase
//   return Array.from(beneficiairesSet);
// };
export const getBeneficiairesFromReceivedChecks = (companies: Company[]): string[] => {
  if (!companies) {
    console.warn("Companies array is null or undefined.");
    return [];
  }

  const beneficiairesSet = new Set<string>();

  companies.forEach(company => {
    if (!company.ribs) {
      console.warn(`Company ${company.id} has no ribs.`);
      return;
    }

    company.ribs.forEach((rib) => {
      if (!rib.recieved_checks) {
        console.warn(`Rib ${rib.id} has no received checks.`);
        return;
      }

      rib.recieved_checks.forEach((receivedCheck) => {
        if (!receivedCheck.beneficiere) {
          console.warn(`Received check ${receivedCheck.id} has no beneficiere.`);
          return;
        }

        beneficiairesSet.add(receivedCheck.beneficiere.toUpperCase());
      });
    });
  });

  return Array.from(beneficiairesSet);
};
